import React, { useState, useEffect } from "react";
import AppBody from "./components/AppBody";
import { useParams } from "react-router-dom";
import { APP_URL } from "../config/api";
import axios from "axios";
const TestBuleButton = () => {
  const [link, setLink] = useState("");
  const [loading, setLoading] = useState("");
  const [errorText, setErrorText] = useState("");
  const { slug } = useParams();

  const checkTab = () => {
    localStorage.openpages = Date.now();
    window.addEventListener(
      "storage",
      function (e) {
        if (e.key == "openpages") {
          this.localStorage.page_available = Date.now();
        }
        if (e.key == "page_available") {
          window.close();
        }
      },
      false
    );
  };

  useEffect(() => {
    checkTab();
    setLoading(true);
    localStorage.setItem("trSlug", slug);
    axios
      .request({
        method: "post",
        url: `${APP_URL}/get-meeting-link`,
        data: { slug: slug },
      })
      .then((res) => {
        console.log(res.data.res);
        setLoading(false);
        setLink(res.data.url);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error.response.statusText);
        setErrorText(error.response.statusText);
      });

      return () => {
        localStorage.removeItem("trSlug");
        localStorage.removeItem("trTopicId");
        localStorage.removeItem("openpages");
        localStorage.removeItem("page_available");
      }
  }, []);

  return (
    <AppBody
      loading={loading}
      content={
        <div>
          {errorText && (
            <div class="alert alert-danger">
              <strong>{errorText}</strong>
            </div>
          )}
          <iframe
            src={link && link}
            width={1100}
            height="580"
            allow="geolocation *; microphone *; camera *; display-capture *;"
            sandbox={
              "allow-same-origin allow-scripts allow-modals allow-forms allow-top-navigation"
            }
            allowFullScreen={"true"}
          >
            <button>Click</button>
          </iframe>
        </div>
      }
    />
  );
};
export default TestBuleButton;
//https://www.google.com/search?q=windows+button+click+on+working+windows+10&rlz=1C1WHAR_enIN933IN933&oq=windows++button+click+on+working+wi&gs_lcrp=EgZjaHJvbWUqCggEECEYFhgdGB4yBggAEEUYOTIHCAEQIRigATIHCAIQIRigATIHCAMQIRigATIKCAQQIRgWGB0YHjIKCAUQIRgWGB0YHjIKCAYQIRgWGB0YHtIBCTE4ODA3ajBqN6gCALACAA&sourceid=chrome&ie=UTF-8#fpstate=ive&vld=cid:d23ba149,vid:peqe0Uq0nhI,st:0
//https://docs.bigbluebutton.org/administration/customize/


